// extracted by css-extract-rspack-plugin
export default {"supportContactsList":"support-contacts-list--yfHoL0XzQMYwxXQy","supportContactItem":"support-contact-item--u5V80ouTV2IQT9Fl","stretched":"stretched--dhUs4VzFdIkTHhFm"};